import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as types from "../actions/actionTypes";
import * as actions from "../actions/eventViewActions";

import { IEvent } from "../classes/event";

export default function eventViewReducer(state: IEvent[] = [], action: Action): IEvent[] {

  if (isType(action, actions.loadCalendarEventsSuccess)) {
    const newState: IEvent[] = [];
    for (const event of action.payload) {
      const newEvent = Object.assign({}, event);
      newState.push(newEvent);
    }
    return newState;
  }

  if (isType(action, actions.clearCalendarEvents)) {
    const newState: IEvent[] = [];
    return newState;
  }

  return state;
};
